<template>
  <!-- <div class="w-full relative">
    <div
      class="lg:pt-24 md:pt-20 pt-20 pb-8 lg:px-20 md:px-10 px-5 absolute top-0 left-0 z-10"
    ></div>
    <p class="text-black covertext1 absolute">Friends Of Caregiversaathi</p>

</div> -->

  <div class="mx-auto lg:px-12 md:px-12 px-5 container lg:py-20 md:py-12 py-6">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4 mob-hidden"
    />
    <UpdateDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />
    <p
      class="text-black fsize32 sm-fsize24 font-semibold lg:pb-6 md:pb-6 pb-4 text-center"
    >
      Recent Updates
    </p>

    <div class="mt-6">
      <div class="lg:mt-6 md:mt-5 mt-4">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide
            v-for="(item, index) in friendsUpdates.result"
            :key="index"
          >
            <div class="bg-fff p-3 rounded-lg">
              <img
                :src="`${$imageURL}/${item.image}`"
                alt="india"
                class="h-280px w-full object-cover rounded-lg"
              />
              <img />
              <div class="text-left">
                <h2 class="uppercase clr-black fsize16 font-semibold pt-4">
                  {{ item.title }}
                </h2>

                <p class="pt-2 clr777 font-normal">
                  {{
                    new Date(item.date).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  }}
                </p>
                <div
                  v-html="item.description"
                  class="ellipsis-2 pt-2 h-16"
                ></div>
                <!-- <a :href="item.link" target="blank">
                    <div class="text-primary flex gap-1 items-center mt-2">
                      <p class="">Go to Website</p>
                      <feather-icon
                        icon="ArrowUpRightIcon"
                        class="cursor-pointer"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </div>
                  </a> -->
                <div>
                  <p class="cursor-pointer" @click="toggleDetails(true, item)">
                    <span class="fsize15 sm-fsize14 text-063a88 underline"
                      >Read more</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
          <div class="swiper-button-next adminswiper" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import UpdateDetailsPopup from "./UpdateDetailsPopup.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
    UpdateDetailsPopup,
  },
  data() {
    return {
      imgUrl: "",
      readmoreblog: false,
      isDetailsActive: false,
      selectedTesimonial: {},
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
          575: {
            slidesPerView: 1,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    ...mapState("friendsUpdates", {
      friendsUpdates: "friendsUpdates",
    }),
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
  },

  async mounted() {
    await this.$store.dispatch("friendsUpdates/getFriends");

    console.log("friendsUpdates", this.friendsUpdates);
  },
};
</script>
